import React from "react"
import { usePromiseTracker } from "react-promise-tracker"
import Loader from "./loader"
import Box from "@material-ui/core/Box"
import Fade from "@material-ui/core/Fade"

const LoadingIndicator = () => {
  const { promiseInProgress } = usePromiseTracker({ delay: 200 })

  return (
    <Fade in={promiseInProgress} timeout={2000}>
      <Box
        className="loading-screen-wrapper"
        display={promiseInProgress ? "block" : "none"}
      >
        <Loader></Loader>
      </Box>
    </Fade>
  )
}

export default LoadingIndicator
